import type { FC } from 'react';

import Icon from 'app/components/Icon';
import ballons from 'app/icons/ballons.svg';

import style from './style.scss';

interface Props {
  name: string;
}

const HappyBirthday: FC<Props> = ({ name }) => (
  <div className={style.container}>
    <div className={style.ballonsContainer}>
      <Icon href={ballons} className={`${style.ballons} ${style.ballons_1}`} />
      <Icon href={ballons} className={`${style.ballons} ${style.ballons_2}`} />
      <Icon href={ballons} className={`${style.ballons} ${style.ballons_3}`} />
      <Icon href={ballons} className={`${style.ballons} ${style.ballons_4}`} />
      <Icon href={ballons} className={`${style.ballons} ${style.ballons_5}`} />
    </div>
    <div className={style.message}>
      Happy Birthday
      <div className={style.name}>🙌 {name} 🙌</div>
    </div>
  </div>
);

HappyBirthday.displayName = 'HappyBirthday';

export default HappyBirthday;
